var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContestStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16428",
    "data-name": "Group 16428",
    transform: "translate(-688 -335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825",
    transform: "translate(687.801 334.801)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(0.199 0.199)",
    fill: "#6fe095",
    stroke: "#6fe095",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10867",
    "data-name": "Path 10867",
    d: "M16.6,5.656a2,2,0,0,1,3.792,0l2.187,6.522a2,2,0,0,0,1.863,1.364l6.83.114a2,2,0,0,1,1.186,3.585L26.926,21.5a2,2,0,0,0-.7,2.16l2.016,6.717a2,2,0,0,1-3.082,2.2l-5.5-3.947a2,2,0,0,0-2.333,0l-5.5,3.947a2,2,0,0,1-3.082-2.2l2.016-6.717a2,2,0,0,0-.7-2.16L4.538,17.241a2,2,0,0,1,1.186-3.585l6.83-.114a2,2,0,0,0,1.863-1.364Z",
    transform: "translate(702 348)",
    fill: "#6fe095"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContestStar);
export default __webpack_public_path__ + "static/media/contest-star.7ea4c7c0552b95b25305140ccd7739d8.svg";
export { ForwardRef as ReactComponent };